import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { blockNavigation, isAuthenticated } from '../utils/auth-utils';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

// no need of this now
const PrivateRoute = ({ children, navigateTo = '/', condition = isAuthenticated() }) => {
  const { userDetails } = useSelector((state) => state.user);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (blockNavigation(userDetails)) {
      navigate('/dashboard/settings?tab=subscription');
    }
  }, [userDetails, location.pathname]);

  if (condition) {
    return <>{children}</>;
  }

  return <Navigate to={navigateTo} />;
};

export default PrivateRoute;
